import type { PhotoDiagnosis, PhotoRecord } from '@greeniq/shared';
import { api } from './client.js';

export interface UploadArgs {
  mimeType: string;
  base64: string;
  originalFilename?: string;
  caption?: string;
  diagnose?: boolean;
}

export interface UploadResponse {
  photo: PhotoRecord & { publicUrl: string };
  diagnosis: PhotoDiagnosis | null;
}

export function uploadPhoto(
  courseSlug: string,
  zoneId: number,
  args: UploadArgs,
): Promise<UploadResponse> {
  return api.post<UploadResponse>(
    `/courses/${courseSlug}/zones/${zoneId}/photos`,
    args,
  );
}

export interface PhotosListResponse {
  photos: PhotoRecord[];
}

export function listZonePhotos(courseSlug: string, zoneId: number): Promise<PhotosListResponse> {
  return api.get<PhotosListResponse>(`/courses/${courseSlug}/zones/${zoneId}/photos`);
}

/** Convert a File to `{ mimeType, base64 }`. Readable by the upload endpoint. */
export async function fileToBase64(file: File): Promise<{ mimeType: string; base64: string; name: string }> {
  const buf = await file.arrayBuffer();
  const bytes = new Uint8Array(buf);
  // Chunked base64 to avoid choking on large images.
  let binary = '';
  const chunk = 0x8000;
  for (let i = 0; i < bytes.byteLength; i += chunk) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  return {
    mimeType: file.type || 'application/octet-stream',
    base64: btoa(binary),
    name: file.name,
  };
}
